import React, { PureComponent } from 'react'
import {
    TextField, PrimaryButton, SpinnerSize, Spinner,
    MessageBarType,
} from '@fluentui/react'
import history from 'helpers/history'
import InvalidEntityError from 'requests/errors/invalidEntityError'
import { ErrorUser } from 'requests/objects/user'
import Status from 'types/status'
import CancelRequestError from 'requests/errors/cancelRequestError'
import NotImplementedError from 'requests/errors/notImplementedError'
import UnauthorizedError from 'requests/errors/unauthorizedError'

/**
 * @augments {React.PureComponent<import('app').AppProps>}
 */
export default class PasswordNew extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            /** @type {string} password */
            password: '',
            /** @type {string} confirmPassword */
            confirmPassword: '',
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
            /** @type {ErrorUser} */
            errorField: new ErrorUser(),
        }
    }

    componentDidMount() {
        const {
            setBreadcrumb, setCommand, setTitle, isAuthenticated, setMessageBar,
        } = this.props

        setBreadcrumb([])
        setCommand([])
        setTitle('')
        setMessageBar({ isDisplayed: false })

        if (isAuthenticated)
            history.push('/')
    }

    componentWillUnmount() {
        this.usersHandlerLogin?.cancel()
    }

    handleSubmit(ev) {
        ev.preventDefault()
        const { usersHandler, match, setMessageBar } = this.props
        const { password, confirmPassword } = this.state

        this.setState({ status: Status.PENDING }, async () => {
            try {
                this.usersHandlerLogin = usersHandler.newPassword(match?.params?.key, { password, confirmPassword })
                await this.usersHandlerLogin.fetch()
                history.push('/login')
                setMessageBar({ // We must set the messagebar after change page, to force re add it
                    isDisplayed: true,
                    type: MessageBarType.success,
                    message: 'Votre mot de passe a bien été modifié.',
                })
            } catch (error) {
                this.setState({ status: Status.REJECTED }, () => {
                    switch (error?.constructor) {
                        case CancelRequestError:
                        case UnauthorizedError: break
                        case NotImplementedError:
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                        case InvalidEntityError:
                            this.setState({ errorField: /** @type {InvalidEntityError<ErrorUser>} */(error).errorField })
                            break
                        default:
                            this.setState({ errorField: new ErrorUser() })
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                    }
                })
            }
        })
    }

    render() {
        const {
            password, confirmPassword, status, errorField,
        } = this.state

        return (
            <form onSubmit={this.handleSubmit.bind(this)}>
                <TextField
                    label="Mot de passe"
                    type="password"
                    value={password}
                    onChange={ev => this.setState({ password: /** @type {HTMLInputElement} */(ev.target).value })}
                    // iconProps={{ iconName: 'PasswordField' }}
                    readOnly={status === Status.PENDING}
                    errorMessage={errorField.password}
                    required
                    canRevealPassword
                />
                <TextField
                    label="Confirmer mot de passe"
                    type="password"
                    value={confirmPassword}
                    onChange={ev => this.setState({ confirmPassword: /** @type {HTMLInputElement} */(ev.target).value })}
                    // iconProps={{ iconName: 'PasswordField' }}
                    readOnly={status === Status.PENDING}
                    errorMessage={errorField.confirmPassword}
                    required
                    canRevealPassword
                />
                <br />
                <div className="flex-row">
                    <PrimaryButton
                        iconProps={{ iconName: 'FollowUser' }}
                        text="Valider"
                        type="submit"
                        disabled={status === Status.PENDING}
                    >
                        {status === Status.PENDING && (
                            <Spinner size={SpinnerSize.small} />
                        )}
                    </PrimaryButton>
                </div>
            </form>
        )
    }
}
